import { render, staticRenderFns } from "./copyToken.vue?vue&type=template&id=3791aafc"
import script from "./copyToken.vue?vue&type=script&lang=js"
export * from "./copyToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports